export const MIME_TYPES = {
  png: 'image/png',
  jpeg: 'image/jpeg',
};

export const MIN_IMAGE_SIZE = 300;
export const MAX_IMAGE_SIZE = 3000;
